var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_226",
    "data-name": "Group 226",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.49,
    height: 11.269,
    viewBox: "0 0 8.49 11.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6411",
    "data-name": "Path 6411",
    d: "M7.554,11.223A.926.926,0,0,0,8.442,10c-.325-1.052-.658-2.1-.988-3.151-.093-.3-.18-.592-.279-.885a1.1,1.1,0,0,1,0-.718C7.593,3.94,8,2.634,8.413,1.329A1.042,1.042,0,0,0,8.43.6.927.927,0,0,0,7.008.183C6.13.8,5.257,1.416,4.381,2.034L.43,4.828a.93.93,0,0,0,0,1.566Q3.7,8.708,6.977,11.016a3.2,3.2,0,0,0,.557.252C7.54,11.254,7.548,11.239,7.554,11.223Z",
    transform: "translate(0 0)",
    fill: "#bac4d2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabLeftArrow);
export default __webpack_public_path__ + "static/media/TabLeftArrow.065ea381c82c3b797fe8c6f0fb0b4ee1.svg";
export { ForwardRef as ReactComponent };